export default "__VITE_ASSET__BsGuRjVi__"